export const ITEMS_PER_PAGE_MOBILE = 6;
export const ITEMS_PER_PAGE_DESKTOP = 9;
export const DEBOUNCE_DELAY = 300;

// Tipos de emendas
export const EMENDA_TYPES = {
  MUNICIPAL: 'municipal',
  ESTADUAL: 'estadual'
};

// Caminhos dos arquivos Excel
export const EXCEL_FILE_PATHS = {
  [EMENDA_TYPES.MUNICIPAL]: '/emendas_impositivas.xlsx',
  [EMENDA_TYPES.ESTADUAL]: '/emendas_estaduais.xlsx'
};

// Labels para exibição
export const EMENDA_LABELS = {
  [EMENDA_TYPES.MUNICIPAL]: 'Emendas Municipais',
  [EMENDA_TYPES.ESTADUAL]: 'Emendas Estaduais'
};

// Manter compatibilidade com código existente
export const EXCEL_FILE_PATH = EXCEL_FILE_PATHS[EMENDA_TYPES.MUNICIPAL];
